const NORMAL_USER_ROLES = [
    {
        label: 'User',
        value: 'USER',
        content: 'Manages account contacts (leads, referrals, enquiries) and dashboard tasks. This user will have access to all contact`s data in the account.',
    },
    {
        label: 'Treatment Coordinator (TCO)',
        value: 'TCO',
        content: 'Manages, creates and edit messages.',
    },
    {
        label: 'Practitioner',
        value: 'Practitioner',
        content: 'Able to see reports only.',
    },
];

const ADMIN_ROLE = {
    label: 'Admin',
    value: 'ADMIN',
    content: 'Manages all account data and perform any action including user management. This user will have access to all contact`s data in the account.',
};

export const getQuickAddUserRoles = ({ isPracticeAdmin, isPracticeOwner, isSuperUser }) => (
    isPracticeAdmin || isPracticeOwner || isSuperUser
        ? [ADMIN_ROLE, ...NORMAL_USER_ROLES]
        : NORMAL_USER_ROLES
);

// Practitioner-dashboard mode intentionally does not remove this entry: the
// backend authorizes every enabled practice member to quick-add normal roles.
export const shouldShowQuickAddUser = ({ hasNavigation }) => Boolean(hasNavigation);
